// Backup servisi - SQL dump/restore ve JSON export/import istekleri
import axios from 'axios';

function normalizeApiUrl(rawUrl) {
  const cleaned = (rawUrl || '').replace(/\/+$/, '');
  if (!cleaned) {
    return '';
  }
  // .env içinde /api unutulursa backup endpoint'leri yanlış path'e gitmesin.
  return cleaned.endsWith('/api') ? cleaned : `${cleaned}/api`;
}

const defaultApiUrl =
  process.env.NODE_ENV === 'development' ? 'http://localhost:5000/api' : 'https://crm.apro.com.tr/api';
const API_URL = normalizeApiUrl(process.env.REACT_APP_API_URL || defaultApiUrl);

const api = axios.create({
  baseURL: API_URL
});

// Token'ı her istekte ekle
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const backupService = {
  exportSqlBackup: () =>
    api.get('/backup/sql/export', {
      responseType: 'blob'
    }),

  restoreSqlBackup: (file) => {
    const formData = new FormData();
    formData.append('backupFile', file);

    return api.post('/backup/sql/restore', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },

  exportJsonBackup: (dataset) =>
    api.get(`/backup/json/export/${dataset}`, {
      responseType: 'blob'
    }),

  restoreJsonBackup: (dataset, file) => {
    const formData = new FormData();
    formData.append('backupFile', file);

    return api.post(`/backup/json/restore/${dataset}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }
};
